// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { PropTypes } from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getViewportInfo, isClient } from '@tcp/core/src/utils';
import styles from './styles/QuantitySelection.style';

const pdpRedesignWidthCheck = (isNewPDPEnabled, isMobile) => {
  return isNewPDPEnabled && !isMobile;
};

const getParentClassName = (className, smallerWidthCheck) => {
  return `container ${className} ${smallerWidthCheck ? 'pdpRedesign' : ''}`;
};

const decreaseDisableClass = (value) => {
  return value - 1 ? 'enabled' : 'disabled';
};

const increaseDisableClass = (value, options) => {
  return value + 1 < options.length + 1 ? 'enabled' : 'disabled';
};

const soldItemOverlay = (isSoldOutItem, isShowDeleteIcon) => {
  return isSoldOutItem && !isShowDeleteIcon && <span className="soldout-overlay" />;
};

const isEnterKey = (e) => {
  return e.keyCode === 13;
};

const handleOnclickDecrease = (value, onChange) => {
  requestAnimationFrame(() => {
    if (value - 1) {
      onChange(value - 1);
    }
  });
};

const handleOnclickIncrease = (value, options, onChange) => {
  requestAnimationFrame(() => {
    if (value + 1 < options.length + 1) {
      onChange(value + 1);
    }
  });
};

// eslint-disable-next-line sonarjs/cognitive-complexity
const QuantitySelection = (props) => {
  const {
    input: { name, ariaLabel, value },
    id,
    placeholder,
    input,
    options,
    dataLocator,
    disabled,
    title,
    input: { onChange },
    showLoader,
    className,
    isNewPDPEnabled,
    isSoldOutItem,
    fromBagPage,
    isBossPickupEdit,
    qtyFrombag,
    isBagDeletionEnabled,
    removeCartItem,
  } = props;
  const isMobile = isClient() ? getViewportInfo()?.isMobile : null;
  const smallerWidthCheck = pdpRedesignWidthCheck(isNewPDPEnabled, isMobile);
  const parentClassName = getParentClassName(className, smallerWidthCheck);
  if (!value && !fromBagPage) {
    onChange(1);
  }
  const isShowDeleteIcon = isBagDeletionEnabled && value <= 1;
  if (!value && isBossPickupEdit && qtyFrombag) {
    onChange(qtyFrombag);
  }
  return (
    <div className={parentClassName}>
      {soldItemOverlay(isSoldOutItem, isShowDeleteIcon)}
      {isShowDeleteIcon ? (
        <div
          className="decreaseButton cart-tile-detelete-wrapper"
          onClick={(e) => {
            e.preventDefault();
            removeCartItem();
          }}
          onKeyDown={(e) => {
            if (isEnterKey(e)) {
              removeCartItem();
            }
          }}
          role="button"
          tabIndex={0}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="12"
            viewBox="0 0 13 12"
            fill="none"
          >
            <path
              d="M4.125 1.08H4C4.06875 1.08 4.125 1.026 4.125 0.96V1.08ZM4.125 1.08H8.875V0.96C8.875 1.026 8.93125 1.08 9 1.08H8.875V2.16H10V0.96C10 0.4305 9.55156 0 9 0H4C3.44844 0 3 0.4305 3 0.96V2.16H4.125V1.08ZM12 2.16H1C0.723437 2.16 0.5 2.3745 0.5 2.64V3.12C0.5 3.186 0.55625 3.24 0.625 3.24H1.56875L1.95469 11.085C1.97969 11.5965 2.42031 12 2.95312 12H10.0469C10.5813 12 11.0203 11.598 11.0453 11.085L11.4312 3.24H12.375C12.4438 3.24 12.5 3.186 12.5 3.12V2.64C12.5 2.3745 12.2766 2.16 12 2.16ZM9.92656 10.92H3.07344L2.69531 3.24H10.3047L9.92656 10.92Z"
              fill="#AAAAAA"
            />
          </svg>
        </div>
      ) : (
        <div
          className={`decreaseButton ${
            smallerWidthCheck ? 'pdpRedesign' : ''
          } ${decreaseDisableClass(value)}`}
          onClick={() => {
            handleOnclickDecrease(value, onChange);
          }}
          onKeyDown={(e) => {
            if (isEnterKey(e)) {
              handleOnclickDecrease(value, onChange);
            }
          }}
          role="button"
          tabIndex={0}
        >
          <div className="decreaseButtonContent" />
        </div>
      )}
      {showLoader ? (
        <div className="spinner-container">
          <div className="spc-spinner">
            <div />
            <div />
          </div>
        </div>
      ) : (
        <div
          {...input}
          id={id}
          aria-label={ariaLabel || title || placeholder}
          className="selected_qty_value"
          name={name}
          value={value || placeholder}
          data-locator={dataLocator}
          disabled={disabled}
        >
          {value || placeholder}
        </div>
      )}
      <div
        className={`increaseButton ${smallerWidthCheck ? 'pdpRedesign' : ''} ${increaseDisableClass(
          value,
          options
        )}`}
        onClick={() => {
          handleOnclickIncrease(value, options, onChange);
        }}
        onKeyDown={(e) => {
          if (isEnterKey(e)) {
            handleOnclickIncrease(value, options, onChange);
          }
        }}
        role="button"
        tabIndex="0"
      >
        <div className="horizontalBarVertical" />
        <div className="horizontalBar" />
      </div>
    </div>
  );
};

QuantitySelection.propTypes = {
  keepAlive: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  meta: PropTypes.shape({}).isRequired,
  input: PropTypes.shape({}).isRequired,
  options: PropTypes.shape([]).isRequired,
  dataLocator: PropTypes.string,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  preText: PropTypes.string,
  forceSelect: PropTypes.bool,
  showLoader: PropTypes.bool,
  isNewPDPEnabled: PropTypes.bool,
  isSoldOutItem: PropTypes.bool,
};

QuantitySelection.defaultProps = {
  keepAlive: false,
  id: '',
  ariaLabel: '',
  name: '',
  type: 'text',
  placeholder: '',
  dataLocator: '',
  disabled: false,
  title: '',
  className: '',
  preText: '',
  forceSelect: false,
  showLoader: false,
  isNewPDPEnabled: false,
  isSoldOutItem: false,
};

export { QuantitySelection as QuantitySelectionVanilla };
export default withStyles(QuantitySelection, styles);
